module.exports = __webpack_public_path__ + "img/直播-active.3d768934.svg";